<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-form-checkbox
          v-model="task.value"
          @change="handleSelectedTask(task, $event)"
        :indeterminate="task.indeterminate"
        ></b-form-checkbox>
      </b-col>
      <b-col cols="6">
        <div class="text-break text-dark">
          {{ task.name }}
        </div>
      </b-col>
      <b-col cols="4" class="d-flex align-items-start justify-content-end px-4">
        <b-form-checkbox
          v-model="task.required"
          switch
          @input="updateRequired(task)"
        ></b-form-checkbox>
        <div class="pt-1">
          <span
            aria-hidden="true"
            aria-expanded="false"
            :aria-controls="`task-${index}`"
            v-if="!showTaskGroup[index]"
            @click="showCollapse(index)"
            class="d-flex align-items-center collapsed"
          >
            <i class="text-dark fa fa-chevron-down ml-2"></i>
          </span>
          <span
            aria-hidden="true"
            aria-expanded="false"
            aria-controls="collapse"
            v-if="showTaskGroup[index]"
            @click="showCollapse(index)"
            class="d-flex align-items-center"
          >
            <i class="text-dark fa fa-chevron-up ml-2"></i>
          </span>
        </div>
      </b-col>
    </b-row>
    <b-collapse :id="`task-${index}`" visible v-model="showTaskGroup[index]">
      <b-list-group>
        <b-list-group-item
          v-for="(subtask, subindex) in task.subtask"
          :key="subindex"
          class="text-dark"
        >
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <b-form-checkbox
                v-model="subtask.value"
                @input="checkSelectedSubTask(task, subtask, $event)"
              ></b-form-checkbox>
              <span>{{ subtask.name }}</span>
            </div>
            <i
              v-if="!subtask.showNote"
              class="fas fa-plus"
              @click="handleShowNote(task, subtask, true)"
            ></i>
            <i
              v-else
              class="fas fa-minus"
              @click="handleShowNote(task, subtask, false)"
            ></i>
          </div>
          <div v-if="subtask.showNote" class="mt-2">
            <b-form-input
              placeholder="Add Note"
              v-model="subtask.note"
              type="text"
              size="sm"
              @change="handleAddNote(task, subtask, subtask.note)"
            ></b-form-input>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-collapse>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "TaskList",
  data() {
    return {
      showTaskGroup: [false],
      id: this.$route.params.id,
    };
  },
  props: {
    task: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    taskListArray: {
      type: Array,
     default: () => [],
    },
    selectedTaskList: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    taskListArray(newVal) {
      newVal.forEach((task) => {
        this.checkIndeterminateState(task);
      });
    },
  },
  methods: {
    ...mapActions([
      "getProposal",
      "editProposal",
      "getBankBranches",
      "dismissed",
      "deleteProposal",
      "getTimeLine",
      "getProposalForEdit",
      "getDocuments",
      "addBuyerTask",
      "addSellerTask",
      "addPropertyTask",
      "deleteSelectedBuyerTask",
      "deleteSelectedSellerTask",
      "deleteSelectedPropertyTask",
      "fetchCommonBuyer",
      "fetchProposalBuyer",
      "updateSelectedBuyerTask",
      "updateSelectedSellerTask",
      "updateSelectedPropertyTask",
      "updateSelectedBuyerRequired",
      "updateSelectedSellerRequired",
      "updateSelectedPropertyRequired",
      "updateSelectedBuyerSubTask",
      "updateSelectedSellerSubTask",
      "updateSelectedPropertySubTask",
      "deleteSelectedBuyerSubTask",
      "deleteSelectedSellerSubTask",
      "deleteSelectedPropertySubTask",
    ]),
    async handleSelectedTask(task, e) {
      // this.$emit("handleLoading", true);
      console.log(this.selectedTaskList, 'this.selectedTaskListthis.selectedTaskList');
      task.value = e;
      if (task.value) {
        for (const element of this.taskListArray) {
          if (element.id === task.id) {
            for (const subtask of element.subtask) {
              subtask.value = e;
              if (this.selectedTaskList == "buyer") {
                await this.updateSelectedBuyerSubTask({
                  task,
                  subtask,
                  id: this.id,
                });
              } else if (this.selectedTaskList == "seller") {
                await this.updateSelectedSellerSubTask({
                  task,
                  subtask,
                  id: this.id,
                });
              } else if (this.selectedTaskList == "property") {
                await this.updateSelectedPropertySubTask({
                  task,
                  subtask,
                  id: this.id,
                });
              }
            }
          }
        }
        if (this.selectedTaskList == "buyer") {
          await this.updateSelectedBuyerTask({ task, id: this.id });
        } else if (this.selectedTaskList == "seller") {
          await this.updateSelectedSellerTask({ task, id: this.id });
        } else if (this.selectedTaskList == "property") {
          await this.updateSelectedPropertyTask({ task, id: this.id });
        }
      } 
      else if (!task.value) {
        this.taskListArray.forEach(async (element) => {
          if (element.id === task.id) {
            for (const subtask of element.subtask) {
              subtask.value = false;
              if (this.selectedTaskList == "buyer") {
                await this.updateSelectedBuyerSubTask({
                  task,
                  subtask,
                  id: this.id,
                });
              }
              if (this.selectedTaskList == "seller") {
                await this.updateSelectedSellerSubTask({
                  task,
                  subtask,
                  id: this.id,
                });
              }
              if (this.selectedTaskList == "property") {
                await this.updateSelectedPropertySubTask({
                  task,
                  subtask,
                  id: this.id,
                });
              }
              if (!subtask.note) {
                if (this.selectedTaskList == "buyer") {
                  await this.deleteSelectedBuyerSubTask({
                    task,
                    subtask,
                    id: this.id,
                  });
                }
                if (this.selectedTaskList == "seller") {
                  await this.deleteSelectedSellerSubTask({
                    task,
                    subtask,
                    id: this.id,
                  });
                }
                if (this.selectedTaskList == "property") {
                  await this.deleteSelectedPropertySubTask({
                    task,
                    subtask,
                    id: this.id,
                  });
                }
              }
            }
            // const allFalse = element.subtask.every(
            //   (el) => el.value === false && el.note === ""
            // );
            // if (allFalse) {
            //   if (this.selectedTaskList == "buyer") {
            //     await this.deleteSelectedBuyerTask({ task, id: this.id });
            //   } else if (this.selectedTaskList == "seller") {
            //     await this.deleteSelectedSellerTask({ task, id: this.id });
            //   } else if (this.selectedTaskList == "property") {
            //     await this.deleteSelectedPropertyTask({ task, id: this.id });
            //   }
            // }
          }
        });
        if (this.selectedTaskList == "buyer") {
          await this.updateSelectedBuyerTask({ task, id: this.id });
        } else if (this.selectedTaskList == "seller") {
          await this.updateSelectedSellerTask({ task, id: this.id });
        } else if (this.selectedTaskList == "property") {
          await this.updateSelectedPropertyTask({ task, id: this.id });
        }
      }
      // await this.$emit("setTaskArray");
    },
    async updateRequired(task) {
      // this.$emit("handleLoading", true);
      if (this.selectedTaskList == "buyer") {
        await this.updateSelectedBuyerRequired({ task, id: this.id });
      } else if (this.selectedTaskList == "seller") {
        await this.updateSelectedSellerRequired({ task, id: this.id });
      } else if (this.selectedTaskList == "property") {
        await this.updateSelectedPropertyRequired({ task, id: this.id });
      }
      // await this.$emit("setTaskArray");
    },
    showCollapse(index) {
      if (this.selectedTaskList === "buyer") {
        this.showTaskGroup[index] = !this.showTaskGroup[index];
        this.$forceUpdate();
      }
      if (this.selectedTaskList === "seller") {
        this.showTaskGroup[index] = !this.showTaskGroup[index];

        this.$forceUpdate();
      }
      if (this.selectedTaskList === "property") {
        this.showTaskGroup[index] = !this.showTaskGroup[index];
        this.$forceUpdate();
      }
    },
    async checkSelectedSubTask(task, subtask, e) {
      this.checkIndeterminateState(task);
      if (e) {
        var booleanArr = [];
        task.subtask.forEach((subTask) => {
          booleanArr.push(subTask.value);
        });
        var allTrue = booleanArr.every((val) => val === true);
        if (this.selectedTaskList === "buyer") {
          if (allTrue) {
            task.value = e;
          }
          await this.updateSelectedBuyerTask({ task, id: this.id });
          this.$emit("setTaskArray");
          this.updateSelectedBuyerSubTask({ task, subtask, id: this.id });
        } else if (this.selectedTaskList === "seller") {
          if (allTrue) {
            task.value = e;
          }
          await this.updateSelectedSellerTask({ task, id: this.id });
          await this.$emit("setTaskArray");
          this.updateSelectedSellerSubTask({ task, subtask, id: this.id });
        } else if (this.selectedTaskList === "property") {
          if (allTrue) {
            task.value = e;
          }
          await this.updateSelectedPropertyTask({ task, id: this.id });
          await this.$emit("setTaskArray");
          this.updateSelectedPropertySubTask({ task, subtask, id: this.id });
        }
      } else {
        task.value = e;
        // const allFalseEmpty = task.subtask.every(
        //   (el) => el.value === false && el.note === ""
        // );
        if (this.selectedTaskList === "buyer") {
          await this.updateSelectedBuyerTask({ task, id: this.id });
          this.updateSelectedBuyerSubTask({ task, subtask, id: this.id });
          // if (allFalseEmpty) {
          //   await this.deleteSelectedBuyerTask({ task, id: this.id });
          // }
        } else if (this.selectedTaskList === "seller") {
          await this.updateSelectedSellerTask({ task, id: this.id });
          this.updateSelectedSellerSubTask({ task, subtask, id: this.id });
          // if (allFalseEmpty) {
          //   await this.deleteSelectedSellerTask({ task, id: this.id });
          // }
        } else if (this.selectedTaskList === "property") {
          await this.updateSelectedPropertyTask({ task, id: this.id });
          this.updateSelectedPropertySubTask({ task, subtask, id: this.id });
          // if (allFalseEmpty) {
          //   await this.deleteSelectedPropertyTask({ task, id: this.id });
          // }
        }
      }
      // if (this.selectedTaskList === "seller") {
      //   if (allTrue) {
      //     this.taskListArray[index].value = true;
      //     await this.addSellerTask({ array: this.taskListArray, id: this.id });
      //   } else {
      //     this.taskListArray[index].value = false;
      //     await this.addSellerTask({ array: this.taskListArray, id: this.id });
      //   }
      // }
      // if (this.selectedTaskList === "property") {
      //   if (allTrue) {
      //     this.taskListArray[index].value = true;
      //     await this.addPropertyTask({
      //       array: this.taskListArray,
      //       id: this.id,
      //     });
      //   } else {
      //     this.taskListArray[index].value = false;
      //     await this.addPropertyTask({
      //       array: this.taskListArray,
      //       id: this.id,
      //     });
      //   }
      // }
    },
    handleShowNote(task, subtask, val) {
      const taskIndex = this.taskListArray.findIndex(
        (el) => el.name === task.name
      );
      const subtaskIndex = this.taskListArray[taskIndex].subtask.findIndex(
        (el) => el.name === subtask.name
      );
      this.taskListArray[taskIndex].subtask[subtaskIndex].showNote = val;
      this.$forceUpdate();
    },
    async handleAddNote(task, subtask, val) {
      if (this.selectedTaskList == "buyer") {
        await this.updateSelectedBuyerSubTask({ task, subtask, id: this.id });
        this.updateSelectedBuyerTask({ task, id: this.id });
      } else if (this.selectedTaskList == "seller") {
        await this.updateSelectedSellerSubTask({ task, subtask, id: this.id });
        this.updateSelectedSellerTask({ task, id: this.id });
      } else if (this.selectedTaskList == "property") {
        await this.updateSelectedPropertySubTask({
          task,
          subtask,
          id: this.id,
        });
        this.updateSelectedPropertyTask({ task, id: this.id });
      }
    },
    checkIndeterminateState(task) {
      const booleanArr = [];
      if (task.subtask && task.subtask.length) {
        task.subtask.forEach((subTask) => {
          booleanArr.push(subTask.value);
        });
        const anyTrue = booleanArr.some((val) => val === true);
        const allTrue = booleanArr.every((val) => val === true);
        if (anyTrue && !allTrue) {
          task.indeterminate = true;
        } else {
          task.indeterminate = false;
        }
        this.$forceUpdate();
      }
    },
  },
};
</script>
